import { render, staticRenderFns } from "./NiceContent.vue?vue&type=template&id=c30a1934&lang=pug&"
import script from "./NiceContent.vue?vue&type=script&lang=ts&"
export * from "./NiceContent.vue?vue&type=script&lang=ts&"
import style0 from "./NiceContent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports